import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-brand-gold bg-brand-cocoa" data-id="element-117" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-118" data-mp="icor512p1ubk">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-gold" data-id="element-119" data-mp="me1xrddm21jj">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-1.5 font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-120" data-mp="wcr7ujz9mhp8">
          Comenzá hoy desde cero y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-xl border-4 border-dashed border-brand-gold bg-white text-brand-choco" data-id="element-121" data-mp="2y3kt9nvxpt55">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-122" data-mp="12p36z8q07qqa">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-123" data-mp="xw0d0zhbef9k" />
          </a>
          <div className="p-3" data-id="element-124" data-mp="oxev96jo349u">
            <p className="font-display text-[0.8rem] font-black uppercase leading-tight text-brand-pink sm:text-sm" data-id="element-125" data-mp="ou0u21mqp13z">
              {PRODUCT_NAME}
            </p>
            <p className="mt-1 inline-block rounded border-2 border-brand-gold bg-brand-choco px-2.5 py-0.5 font-display text-sm font-black uppercase tracking-wide text-white" data-id="element-126" data-mp="1gocjnyf042pi">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-[0.75rem] text-brand-choco/80" data-id="element-127" data-mp="17mbs9i6g8avr">
              🎁 Bonos valorados en{' '}
              <span className="font-semibold text-brand-pinkdark line-through" data-id="element-128" data-mp="14g95d70zts2">
                {BONUS_VALUE}
              </span>
            </p>

            <p className="mt-1.5 inline-block rounded bg-brand-pink px-2.5 py-0.5 font-display text-[0.62rem] font-black uppercase tracking-wide text-white" data-id="element-129" data-mp="3ttpzsepixvfc">
              🔥 Oferta especial
            </p>

            <p className="mt-1 font-display text-5xl font-black leading-none tracking-tight text-brand-pink sm:text-6xl" data-id="element-130" data-mp="3ks9q696j9xc6">
              Hoy: {PRICE}
            </p>
            <p className="mt-1 text-[0.7rem] font-medium text-brand-choco/80" data-id="element-131" data-mp="3b3hze4d7lj2u">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-132" data-mp="3fvt0vbnllcxi">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>

            <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-brand-choco/80" data-id="element-133" data-mp="363ncsd0gvfnl">
              <span className="flex items-center gap-1" data-id="element-134" data-mp="2s5fi6bqwkqfl">
                <ZapIcon size={12} className="text-brand-pink" data-id="element-135" data-mp="2x4089icfxtqb" />
                Acceso Inmediato
              </span>
              <span className="text-brand-choco/40" data-id="element-136" data-mp="2diq8xi6umyw0">•</span>
              <span className="flex items-center gap-1" data-id="element-137" data-mp="28j3vb7n3zgmo">
                <ShieldCheckIcon size={12} className="text-brand-gold" data-id="element-138" data-mp="28kos73wwbbnp" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}